import { render, staticRenderFns } from "./SettingsLabelWidgetSnippet.vue?vue&type=template&id=33983aa2&scoped=true"
import script from "./SettingsLabelWidgetSnippet.vue?vue&type=script&lang=js"
export * from "./SettingsLabelWidgetSnippet.vue?vue&type=script&lang=js"
import style0 from "./SettingsLabelWidgetSnippet.vue?vue&type=style&index=0&id=33983aa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33983aa2",
  null
  
)

export default component.exports